import { IStrikeReportFilterDisplay } from './strike-report.types';

export const STRIKE_REPORT_DISPLAY: IStrikeReportFilterDisplay[] = [
  { value: 'emptyExpiries', label: 'Empty Expires', isVisible: true },
  { value: 'emptyStrikes', label: 'Empty Strikes', isVisible: true },
];

export const STRIKE_REPORT_FILTER_DISPLAY_INITIAL_STATE: string[] = STRIKE_REPORT_DISPLAY.map(
  (item) => item.value,
);

export const STRIKE_REPORT_KEY = 'STRIKE_REPORT';
